module.exports = __webpack_public_path__ + "img/logo_konsuldok.d47c76c0.png";